<template>
	<div class="px-2.5 text-center font-Inter">
		<h2 class="text-[30px] leading-[36px] font-bold text-won-blue">
			Get help from a pro!
		</h2>

		<p class="mt-4 text-center text-[14px] leading-[17px] font-medium tracking-[2%] text-won-ash-gray">
			Looking for professional guidance? We can help!
			<br /><br />

			90% of our clients land
			<span class="font-bold"> interviews </span>
			within 3 months and 70% land
			<span class="font-bold"> offers </span>
			in 6 months!
		</p>

		<div class="mt-11">
			<p class="text-left! text-[13px] leading-[16px] font-semibold tracking-[2%] text-won-dark-blue italic">
				"Wonsulting saved me time applying to jobs I didn’t know I should be applying to. I might say that it simplified the job search process and overall saved me time while I was interviewing. Besides that I would say that I really liked the service and found it useful. I don’t think that I would had applied that much on my own."
			</p>

			<div class="mx-auto mt-6 flex w-fit items-center gap-2.5 text-left font-semibold">
				<div class="size-10 overflow-hidden rounded-full">
					<img
						:src="AlfredoSerano"
						alt="Alfredo Serano"
						class="h-full w-auto object-cover"
					/>
				</div>
				3
				<div>
					<span class="block text-[19px] leading-[23px] text-won-dark-blue">Alfredo Serrano</span>
					<span class="mt-0.5 block text-[12px] leading-[14px] text-[#929497]">
						Data Science Consultant at MS
					</span>
				</div>
			</div>
		</div>

		<div class="mt-20 mb-5 text-[16px] leading-[19px]">
			<button
				class="rounded bg-won-green px-[77px] py-[9px] text-white"
			>
				Explore Our Job Search Bundles
			</button>
		</div>
	</div>
</template>

<script setup>
const AlfredoSerano = '/img/alfredo-serano.webp';
</script>
